"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    primary: {
        gridTemplateRows: "repeat(12, 1fr)",
        gridTemplateColumns: "repeat(12, 1fr)",
        gap: 2
    }
};
